import { getBreakPointByWidth } from "../plugins/breakpoints.mjs";
import { debounce } from "@spoferan/spoferan-ts-core";
function mounted(el, binding) {
  setTimeout(() => {
    adaptStyle(el, binding);
  }, 0);
}
function adaptStyle(el, binding) {
  if (!binding.value) {
    return;
  }
  const targetStyleProp = binding.arg || "height";
  const plainTargetStyleProp = `offset${targetStyleProp.charAt(0).toUpperCase() + targetStyleProp.slice(1)}`;
  const bindingData = typeof binding.value === "string" ? { selector: binding.value } : binding.value;
  const targetSelector = bindingData.selector;
  const targets = Array.prototype.slice.call(el.querySelectorAll(targetSelector));
  const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  const currentBreakpoint = getBreakPointByWidth(windowWidth);
  const cellsPerRow = 12;
  const elementsPerRow = bindingData[currentBreakpoint] ? cellsPerRow / bindingData[currentBreakpoint] : targets.length;
  let i, j, chunkTargets;
  for (i = 0, j = targets.length; i < j; i += elementsPerRow) {
    chunkTargets = targets.slice(i, i + elementsPerRow);
    let highestStyle = 0;
    for (let i2 = 0; i2 < chunkTargets.length; i2++) {
      const targetStyle = chunkTargets[i2].style[targetStyleProp];
      chunkTargets[i2].style[targetStyleProp] = null;
      const plainTargetStyle = chunkTargets[i2][plainTargetStyleProp];
      if (plainTargetStyle > highestStyle) {
        highestStyle = plainTargetStyle;
      }
      chunkTargets[i2].style[targetStyleProp] = targetStyle;
    }
    for (let i2 = 0; i2 < chunkTargets.length; i2++) {
      chunkTargets[i2].style[targetStyleProp] = `${highestStyle}px`;
    }
  }
}
function updated(el, binding) {
  adaptStyle(el, binding);
}
export const Adapt = {
  mounted,
  updated: debounce(updated, 150)
  // Debounce to avoid costly calculations when multiple updates occur
};
export default Adapt;
